module.exports = __webpack_public_path__ + "media/images/useek_logo-86179598889a542211f0ccd3c2e18143.png";